import React from "react";
import { CompanyCanReceivePeppol } from "./CompanyCanReceivePeppol";
import { InvoiceV2Api } from "queries/InvoiceV2";
import { CompanyApi } from "queries/Company";
import { Loading } from "components/panels";
import { BookkeepingNotRegisteredForPeppol } from "./BookkeepingNotRegisteredForPeppol";

interface Props {
  invoiceId: number;
  addresseeCompanyId: number;
}

export const PeppolBeforeInvoiceSent = (props: Props) => {
  const invoiceSidePanelData = InvoiceV2Api.GetSidePanelData.useQuery(props.invoiceId, {});

  const companyCanReceivePeppolApi = CompanyApi.CanReceivePeppol.useQuery(props.addresseeCompanyId, {
    enabled: invoiceSidePanelData.data != null && invoiceSidePanelData.data.data.senderIsPeppolRegistered
  });

  if (!invoiceSidePanelData.data) {
    return <Loading />
  }

  if (!invoiceSidePanelData.data.data.senderIsPeppolRegistered) {
    return <BookkeepingNotRegisteredForPeppol />
  }

  if (!companyCanReceivePeppolApi.data) {
    return <Loading />
  }

  return <CompanyCanReceivePeppol compliance={companyCanReceivePeppolApi.data.data} />
}